import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const PendingIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4988 9.9125C20.7749 9.9125 20.9988 9.68864 20.9988 9.4125V4.02469C20.9988 3.57575 20.453 3.35428 20.1402 3.67628L18.2688 5.6025C14.7588 2.1325 9.12878 2.1325 5.61878 5.6025C2.10878 9.0725 2.13878 14.7125 5.63878 18.1825C9.14878 21.6625 14.8488 21.6625 18.3588 18.1825C19.8353 16.7228 20.6925 14.6789 20.9303 12.8893C21.003 12.3418 20.5511 11.8925 19.9988 11.8925C19.4465 11.8925 19.0073 12.3424 18.937 12.8901C18.7414 14.4121 18.0821 15.6757 16.9588 16.7825C14.2288 19.4925 9.80878 19.4925 7.07878 16.7825C4.34878 14.0725 4.34878 9.7025 7.07878 6.9925C9.80878 4.2925 14.2288 4.3925 16.9588 7.0925L15.0431 9.06407C14.7351 9.38107 14.9598 9.9125 15.4017 9.9125H20.4988ZM12.4988 8.5425C12.4988 8.12829 12.163 7.7925 11.7488 7.7925C11.3346 7.7925 10.9988 8.12829 10.9988 8.5425V12.8215C10.9988 12.9933 11.087 13.1531 11.2324 13.2446L14.6242 15.3803C14.9802 15.6045 15.4514 15.4847 15.6572 15.1178C15.8486 14.7764 15.7391 14.3449 15.4081 14.1362L12.4988 12.3018V8.5425Z"
      />
    </Icon>
  );
};
